import * as React from "react";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/joy/Typography";

export default function OrgTag({ label, abvr, src, color, size }) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Chip
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      avatar={<Avatar alt={abvr} src={src} />}
      label={
        isHovered ? (
          <Typography
            color="white"
            level={size === "medium" ? "body-sm" : "body-xs"}
          >
            {label}
          </Typography>
        ) : (
          <Typography
            color="white"
            level={size === "medium" ? "body-sm" : "body-xs"}
          >
            {abvr}
          </Typography>
        )
      }
      size="medium"
      sx={{
        backgroundColor: color,
        color: "white",
        transition: "all .5s ease",
      }}
    />
  );
}
